
(function(){
  var main = document.getElementById('mainImg');
  var thumbs = document.querySelectorAll('.gallery__thumbs button');
  var swatches = document.querySelectorAll('.swatch');
  var colorName = document.getElementById('colorName');
  var bundles = document.querySelectorAll('.bundle');
  var priceNow = document.getElementById('priceNow');
  var ctaTotal = document.getElementById('ctaTotal');
  var mbarTotal = document.getElementById('mbarTotal');

  function setMain(src, el){
    main.src = src;
    thumbs.forEach(function(t){ t.classList.toggle('is-on', t===el); });
  }
  thumbs.forEach(function(t){ t.addEventListener('click', function(){ setMain(t.getAttribute('data-src'), t); }); });

  swatches.forEach(function(sw){
    sw.addEventListener('click', function(){
      swatches.forEach(function(s){ s.classList.remove('is-sel'); s.setAttribute('aria-checked','false'); });
      sw.classList.add('is-sel'); sw.setAttribute('aria-checked','true');
      colorName.textContent = sw.getAttribute('data-name');
      // change l'image principale + le thumb correspondant
      var img = sw.getAttribute('data-img');
      var match = Array.prototype.find.call(thumbs, function(t){ return t.getAttribute('data-src')===img; });
      setMain(img, match || null);
    });
  });

  bundles.forEach(function(b){
    b.addEventListener('click', function(){
      bundles.forEach(function(x){ x.classList.remove('is-sel'); x.setAttribute('aria-checked','false'); });
      b.classList.add('is-sel'); b.setAttribute('aria-checked','true');
      var total = b.getAttribute('data-total');
      if(priceNow) priceNow.textContent = total;
      if(ctaTotal) ctaTotal.textContent = total;
      if(mbarTotal) mbarTotal.textContent = total;
    });
  });
})();



/* ── Panier Shopify : ajoute la variante (coloris + pack) puis checkout ── */
(function(){
  var packLabel={"1":"1 sac","2":"2 sacs","3":"3 sacs"};
  var btn=document.getElementById('addCart'); if(!btn) return;
  btn.addEventListener('click',function(){
    var sw=document.querySelector('.swatch.is-sel'); var color=sw?sw.getAttribute('data-name'):'Noir';
    var bl=document.querySelector('.bundle.is-sel'); var qty=bl?bl.getAttribute('data-qty'):'1';
    var key=color+'|'+packLabel[qty]; var id=(window.KUZ_VARIANTS||{})[key];
    if(!id){alert('Variante indisponible');return;}
    var old=btn.textContent; btn.disabled=true; btn.textContent='Ajout en cours…';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
      .then(function(r){return r.json();}).then(function(){window.location.href='/checkout';})
      .catch(function(){btn.disabled=false;btn.textContent=old;alert('Une erreur est survenue, réessayez.');});
  });
})();
